.betTypeFilters {
  gap: 0;
}

.select label {
  gap: var(--cxy-spacing-xxsm);
  display: flex;
  align-items: center;
}
